module.exports = __webpack_public_path__ + "img/upload-file.04f35a72.svg";